(() => {
  const bindCursor = (slider) => {
    if (slider.dataset.cursorBound) return;
    slider.dataset.cursorBound = 'true';

    const startDrag = () => {
      slider.classList.add('is-dragging');
      document.body.classList.add('before-after-dragging');
    };

    const endDrag = () => {
      slider.classList.remove('is-dragging');
      document.body.classList.remove('before-after-dragging');
    };

    slider.addEventListener('mousedown', startDrag);
    slider.addEventListener('touchstart', startDrag, { passive: true });
    window.addEventListener('mouseup', endDrag);
    window.addEventListener('touchend', endDrag);
    window.addEventListener('touchcancel', endDrag);
  };

  const init = (root = document) => {
    root.querySelectorAll('.before-after__slider').forEach(bindCursor);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
